export default __webpack_public_path__ + "static/index_about_hospital-700c989f5f70170b116a7018e3804428.png";